import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHeadspaceComponent } from './simple-icons-headspace.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHeadspaceComponent ],
    exports:      [ SimpleIconsHeadspaceComponent ],
    bootstrap:    []
})
export class SimpleIconsHeadspaceModule {}
